<template>
  <side-panel-inner class="idea">
    <template slot="actions">
      <base-button @click="addSystem" :primary="true" iconBefore="tick">Update</base-button>
    </template>
    <h2 slot="header" class="c-panel__header-title">Update system status</h2>
    <loading v-if="loading"/>
    <div class="negative-margin" v-else>
      <form>
        <message type="error" v-if="showValidationMessage">
          <h3>Form Invalid</h3>
          <p>Form is invalid, please check and try again.</p>
          <ul>
            <li v-for="error in errors.items" :key="error.id">{{error.msg}}</li>
          </ul>
        </message>

        <p>
          You are currently updating the status for
          <strong>{{system.name}}</strong>
        </p>

        <form-options
          label="What is the status of the system?"
          v-model="system.status_id"
          name="status"
          :options="statusOptions"
          v-validate="{required: true}"
          data-vv-as="status"
          :error="errors.first('status')"
        ></form-options>

        <form-field
          full-width
          label="Short Description"
          name="short_description"
          helper-text="What category does the issue fall into"
          required
        >
          <form-multiselect
            :show-valid-tick="false"
            :show-drop-icon="true"
            ref="filter"
            placeholder="Select a description"
            v-model="status.short_description"
            :options="shortDescOptions"
            :multiple="false"
            label="label"
            track-by="label"
            :searchable="true"
            :limit="1"
            :long="true"
            required
            v-validate="{required: true}"
            name="short_description"
            data-vv-as="short description"
            :error="errors.first('short_description')"
          ></form-multiselect>
        </form-field>

        <form-field
          full-width
          label="Details"
          name="description"
          helper-text="Please try to describe the issue"
          required
          type="textarea"
          v-validate="{required: true}"
          data-vv-as="description"
          :error="errors.first('description')"
          v-model="status.description"
        ></form-field>

        <form-field
          full-width
          label="Back Online?"
          name="details"
          helper-text="When is it estimated that the system will be back online? If the system is back online, please select the time it was restored"
          required
          v-model="status.end_date"
        >
          <time-picker
            v-validate="{required: true}"
            v-model="status.end_date"
            placeholder="Select time"
            name="end_date"
            data-vv-as="end time"
            :workingDay="false"
            :error="errors.first('end_date')"
          ></time-picker>
        </form-field>
      </form>
    </div>
  </side-panel-inner>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import UserHasPermission from "@/mixins/UserHasPermission";
import { TimePicker } from "@/components/forms";

export default {
  name: "SystemStatusAdd",

  data() {
    return {
      showValidationMessage: false,
      loading: false
    };
  },

  /**
   * TODO:
   * What we need to do is determine whether we are posting to a main comment or a reply
   * This should be similar in nature to the pages, so look at how that is done
   */
  methods: {
    addSystem() {
      const vm = this;
      this.$validator.validate().then(result => {
        if (!result) {
          vm.validationFailed = true;
        } else {
          // depending on the status that has been sent, we need to change the status
          let systemEndpoint;
          const id = this.$route.params.id;
          switch (this.system.status_id) {
            case 1:
              systemEndpoint = `systems/markAsOnline`;
              break;
            case 2:
              systemEndpoint = `systems/markAsIssue`;
              break;
            default:
              systemEndpoint = `systems/markAsOffline`;
              break;
          }

          // need to alter the payload
          /**
           * {
	"update": {
		"update_date": null,
		"end_date": "17:00",
		"title": null,
		"description": "system is offline",
		"status_id": 4,
		"title": "Full System Failure"
		
	}
}
           */
          const payload = {
            end_date: this.status.end_date,
            title: this.status.short_description.label,
            description: this.status.description,
            status_id: id
          };
          vm.$store
            .dispatch(systemEndpoint, id)
            .then(resp => {
              vm.$store
                .dispatch("systems/update", {
                  id,
                  payload
                })
                .then(() => {
                  vm.system.status_id = null;
                  vm.$store.commit('systems/SET_STATUS',[]);
                  vm.$store.dispatch("CLOSE_PANEL");
                });
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    }
  },

  computed: {
    ...mapState("systems", ["system", "status"]),
    shortDescOptions() {
      return [
        { id: 1, label: "No Issues" },
        { id: 2, label: "At Risk Period" },
        { id: 3, label: "Full System Failure" },
        { id: 4, label: "Maintenance Work" },
        { id: 5, label: "Data Feed Delay" },
        { id: 6, label: "Data Feed Difficulties" }
      ];
    },
    statusOptions() {
      return [
        {
          label: `Green`,
          value: 1,
          content: "There are no issues with the system"
        },
        {
          label: `Amber`,
          value: 2,
          content: "Some non-critical issues detected"
        },
        {
          label: `Red`,
          value: 0,
          content: "There are critical issues detected"
        }
      ];
    }
  },
  components: { TimePicker },

  mixins: [UserHasPermission],

  mounted() {
    this.$store.commit('systems/SET_STATUS',[]);
  },

  created() {
    this.$store.commit('systems/SET_STATUS',[]);
    this.$store.dispatch("systems/read", this.$route.params.id);
  }
};
</script>


<style lang="scss" scoped>
</style>
